import * as React from 'react';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { TreeNodeType } from '../../../../lib/types/types';
import { CustomTreeItem } from './TreeNavigationItems';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, Paper } from '@mui/material';
import { useApplication } from '../../../../context/ApplicationContext';
import { useNavigate } from 'react-router-dom';

type TreeViewNavigationProps = {
	treeStructure: TreeNodeType[];
	currentNode: string[];
	handleNavigation: (nodeIds: string[], buttonClick?: string) => void;
};
const TreeViewNavigation: React.FC<TreeViewNavigationProps> = ({ treeStructure, currentNode, handleNavigation }) => {
	const { saveApplication, readOnly } = useApplication();
	const navigate = useNavigate();
	const handleNodeChange = (_e: React.SyntheticEvent, itemIds: string[]) => {
		handleNavigation(itemIds);
	};

	// This removes the children so that the onClick on the Tree navigates only through the Nodes and not children
	const newTreeStructure = treeStructure.map(({ children, ...rest }) => rest);

	return (
		<>
			<Button
				variant="outlined"
				startIcon={<ArrowBackIcon />}
				sx={{ width: '100%', margin: '1rem auto' }}
				onClick={async () => {
					saveApplication();
					navigate('/meine-antraege');
				}}
			>
				{readOnly ? 'Zurück' : 'Speichern und zurück'}
			</Button>
			<Paper sx={{ maxWidth: '18.75rem', padding: '1rem', borderRadius: '1rem' }}>
				<RichTreeView
					multiSelect={true}
					items={newTreeStructure}
					selectedItems={currentNode}
					expandedItems={currentNode}
					onSelectedItemsChange={handleNodeChange}
					sx={{ height: 'fit-content', flexGrow: 1, maxWidth: 400, overflowY: 'auto' }}
					slots={{ item: CustomTreeItem }}
				/>
			</Paper>
		</>
	);
};
export default TreeViewNavigation;
